var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShower = function SvgShower(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.659,
    height: 26.67
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#2a4d4f"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3958",
    d: "M15.412 17.495a.416.416 0 0 0-.417.417v1.666a.417.417 0 0 0 .833 0v-1.666a.416.416 0 0 0-.417-.417Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3959",
    d: "M15.412 14.996a.416.416 0 0 0-.417.417v.833a.417.417 0 0 0 .833 0v-.833a.416.416 0 0 0-.417-.417Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3960",
    d: "M15.412 20.828a.416.416 0 0 0-.417.417v1.666a.417.417 0 1 0 .833 0v-1.666a.416.416 0 0 0-.417-.417Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3961",
    d: "M15.412 24.16a.416.416 0 0 0-.417.417v1.666a.417.417 0 0 0 .833 0v-1.666a.416.416 0 0 0-.417-.417Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3962",
    d: "M20.203 15.781a.416.416 0 0 0-.153.569l.833 1.443a.417.417 0 1 0 .722-.417l-.833-1.443a.417.417 0 0 0-.569-.152Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3963",
    d: "M22.438 18.82a.417.417 0 1 0-.722.417l.833 1.443a.417.417 0 1 0 .722-.417Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3964",
    d: "M24.104 21.706a.417.417 0 1 0-.722.417l.833 1.443a.417.417 0 1 0 .722-.417Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3965",
    d: "m26.603 26.035-.833-1.443a.417.417 0 0 0-.722.417l.833 1.443a.417.417 0 1 0 .722-.417Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3966",
    d: "m18.544 16.703-.57-1.566a.416.416 0 0 0-.782.285l.57 1.566a.417.417 0 0 0 .392.274.384.384 0 0 0 .142-.026.416.416 0 0 0 .25-.533Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3967",
    d: "m19.683 19.837-.57-1.566a.417.417 0 1 0-.783.284l.571 1.566a.416.416 0 1 0 .782-.284Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3968",
    d: "m20.824 22.968-.57-1.566a.416.416 0 0 0-.782.285l.57 1.566a.415.415 0 0 0 .391.274.393.393 0 0 0 .143-.026.415.415 0 0 0 .249-.533Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3969",
    d: "M21.394 24.535a.417.417 0 1 0-.783.285l.57 1.565a.417.417 0 0 0 .783-.284Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3970",
    d: "M13.385 14.891a.413.413 0 0 0-.319.014.418.418 0 0 0-.216.236l-.57 1.562a.416.416 0 0 0 .25.533.392.392 0 0 0 .142.026.415.415 0 0 0 .392-.274l.57-1.566a.417.417 0 0 0-.25-.531Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3971",
    d: "M12.244 18.022a.416.416 0 0 0-.533.25l-.57 1.566a.416.416 0 0 0 .245.545.421.421 0 0 0 .324-.017.415.415 0 0 0 .213-.244l.57-1.566a.415.415 0 0 0-.014-.32.42.42 0 0 0-.235-.216Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3972",
    d: "M11.104 21.154a.414.414 0 0 0-.533.25L10 22.973a.416.416 0 0 0 .25.533.393.393 0 0 0 .143.026.417.417 0 0 0 .392-.274l.57-1.566a.416.416 0 0 0-.25-.533Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3973",
    d: "M9.964 24.285a.416.416 0 0 0-.533.25l-.57 1.566a.416.416 0 0 0 .007.324.421.421 0 0 0 .237.22.417.417 0 0 0 .537-.259l.57-1.565a.425.425 0 0 0-.014-.32.418.418 0 0 0-.236-.216Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3974",
    d: "m10.052 15.933-.833 1.443a.417.417 0 1 0 .722.417l.833-1.443a.417.417 0 0 0-.722-.417Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3975",
    d: "M8.956 18.667a.417.417 0 0 0-.57.153l-.833 1.443a.417.417 0 1 0 .722.417l.833-1.443a.417.417 0 0 0-.152-.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3976",
    d: "M7.289 21.553a.417.417 0 0 0-.57.153l-.833 1.443a.417.417 0 1 0 .722.417l.833-1.443a.417.417 0 0 0-.152-.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3977",
    d: "M5.623 24.439a.411.411 0 0 0-.317-.042.415.415 0 0 0-.253.194l-.833 1.443a.417.417 0 1 0 .722.417l.833-1.443a.414.414 0 0 0-.152-.569Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3978",
    d: "M11.247 2.499a2.919 2.919 0 0 1 2.916 2.916v.972a5.836 5.836 0 0 0-4.565 5.276h-.017a1.25 1.25 0 0 0 0 2.5h11.663a1.25 1.25 0 0 0 0-2.5h-.021a5.836 5.836 0 0 0-4.561-5.277v-.971a5.422 5.422 0 0 0-5.415-5.416H5.415A5.422 5.422 0 0 0-.002 5.415v20.828a.416.416 0 0 0 .417.417h1.668a.416.416 0 0 0 .417-.417V5.415a2.919 2.919 0 0 1 2.915-2.916Zm10.414 10.414a.416.416 0 0 1-.417.417H9.58a.417.417 0 0 1 0-.833h11.664a.416.416 0 0 1 .417.417Zm-1.263-1.25H10.43a5 5 0 0 1 9.964 0ZM1.666 5.415v20.411H.833V5.415A4.587 4.587 0 0 1 5.415.833h5.832a4.587 4.587 0 0 1 4.581 4.582v.854c-.139-.01-.276-.021-.417-.021s-.278.011-.417.021v-.854a3.753 3.753 0 0 0-3.749-3.749h-5.83a3.753 3.753 0 0 0-3.749 3.749Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3979",
    d: "M13.504 8.378a4.215 4.215 0 0 0-1.82 1.851.417.417 0 0 0 .747.371 3.37 3.37 0 0 1 1.453-1.483.417.417 0 0 0-.06-.774.421.421 0 0 0-.323.034Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3980",
    d: "M14.579 7.914h.833v.833h-.833Z"
  }))));
};
export default SvgShower;